import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import LogoHeader from "../../components/LogoHeader";
import Header from "../../components/Header";
import CustomButton from "../../components/CustomButton";

const RegisterComplete = () => {
    const navigate = useNavigate();
    const { companyInfo, urlSlug } = useSelector((state: any) => state.talentRegister);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        window.location.href = urlSlug
    };

    return (
        <div className='static md:fixed md:inset-0 bg-alu-base'>
            <div className='w-full md:max-w-[50rem] static md:absolute left-1/2 md:transform md:-translate-x-1/2 md:py-[2.5rem] md:px-[2.25rem]'>
                <LogoHeader view="talent" page="advanced"></LogoHeader>
                <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-full md:m-auto md:min-h-max min-h-screen w-full px-0 py-0 md:px-6 md:py-6'>
                    <Header title="登録完了" logoDirection="row"></Header>
                    <div className="flex flex-col items-center justify-center mt-[2.5rem] md:mt-4 px-4">
                        <form onSubmit={handleSubmit} className="bg-white w-full">
                            <div className="mb-4 inline-block w-full">
                            <p className="text-base font-bold alu-text-base-2">
                                ご登録ありがとうございます！<br/>
                                aloopは、あなたと{companyInfo.name}を繋ぎ、新たな可能性を広げるための特別な場所です。<br/>
                                ご登録いただいたメールアドレス宛に、ログインのご案内を送付させていただきます。
                            </p>
                            </div>
                            {/* <div className="mt-4 flex justify-center">
                                <CustomButton customStyle="min-w-[8.75rem]" type="submit">
                                    トップページへ戻る
                                </CustomButton>
                            </div> */}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterComplete;
